/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Overwrite_AllInputs */

const cs_ebr_overwrite_all = /** @type {(inputs: Ebr_Overwrite_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přepsat vše z eBrány`)
};

const en_ebr_overwrite_all = /** @type {(inputs: Ebr_Overwrite_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overwrite all from eBrána`)
};

/**
* | output |
* | --- |
* | "Overwrite all from eBrána" |
*
* @param {Ebr_Overwrite_AllInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_overwrite_all = /** @type {((inputs?: Ebr_Overwrite_AllInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Overwrite_AllInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_overwrite_all(inputs)
	return cs_ebr_overwrite_all(inputs)
});